import React, { Fragment } from 'react';

import { Text } from '@chakra-ui/react';
import { Components } from 'react-markdown';

import { LINK_CLASS } from '@/components/common/Markdown';

import styles from './SessionList.module.scss';

export const MARKDOWN_COMPONENTS: Partial<Components> = {
  hr: () => null,
  image: ({ href }) => (
    <Text as='span' fontSize={'md'} lineHeight={'6'}>
      {href}
    </Text>
  ),
  code: function CodeComponent({ children }) {
    return (
      <Text as='span' fontSize={'md'} lineHeight={'6'}>
        {children}
      </Text>
    );
  },
  strong: function StrongComponent({ children }) {
    return (
      <Text as='span' fontWeight={'bold'} fontSize={'md'}>
        {children}
      </Text>
    );
  },
  i: function StrongComponent({ children }) {
    return (
      <Text as='span' fontSize={'md'}>
        {children}
      </Text>
    );
  },
  pre: function PreComponent({ children }) {
    return <>{children}</>;
  },
  h1: ({ children }) => (
    <Text fontWeight={'semibold'} fontSize={'md'}>
      {children}
    </Text>
  ),
  h2: ({ children }) => (
    <Text fontWeight={'semibold'} fontSize={'md'}>
      {children}
    </Text>
  ),
  h3: ({ children }) => (
    <Text fontWeight={'semibold'} fontSize={'md'}>
      {children}
    </Text>
  ),
  h4: ({ children }) => (
    <Text fontWeight={'semibold'} fontSize={'md'}>
      {children}
    </Text>
  ),
  a: ({ children, href }) => (
    <a
      href={href}
      className={LINK_CLASS}
      onClick={e => {
        e.preventDefault();
      }}
    >
      {children}
    </a>
  ),
  blockquote: ({ children }) => (
    <>
      &ldquo;
      <Text as='span' fontSize={'md'} className={styles.markdownBlockquote}>
        {children}
      </Text>
      &rdquo;
    </>
  ),
  ul: ({ children }) => {
    const items = React.Children.toArray(children).filter(
      child => typeof child === 'object'
    );
    return (
      <>
        {items.map((child, index) => (
          <Fragment key={index}>
            <Text as='span' fontSize={'md'}>
              {'•'}
            </Text>
            <Text as='span' fontSize={'md'} className={styles.markdownLi}>
              {child}
            </Text>
            <br />
          </Fragment>
        ))}
      </>
    );
  },
  ol: ({ children }) => {
    const items = React.Children.toArray(children).filter(
      child => typeof child === 'object'
    );
    return (
      <>
        {items.map((child, index) => (
          <Fragment key={index}>
            <Text as='span' fontSize={'md'}>
              {index + 1}.
            </Text>
            <Text as='span' fontSize={'md'} className={styles.markdownLi}>
              {child}
            </Text>
            <br />
          </Fragment>
        ))}
      </>
    );
  },
  p: ({ children }) => {
    return (
      <Text as='p' fontSize={'md'}>
        {children}
      </Text>
    );
  },
  li: ({ children }) => {
    return <>{children}</>;
  },
  table: () => {
    return (
      <Text as='p' fontWeight={'semibold'} fontSize={'md'}>
        Table view.
      </Text>
    );
  },
};
